import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import sellImages from "../../../../assets/images/sell_physical_recharge_plan_id_17_image.png";
import swal from 'sweetalert';
import { Navigate, useNavigate } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner'
import { toast } from 'react-toastify';

import shopping from "assets/images/shopping.png";
import Icon from "@mui/material/Icon";
import Loader from "./loader";




const SERVER_URL = process.env.REACT_APP_API_URL;


const Confirm = ({ mobile, handlePage, confirmation, choosedVoucherCount, choosedplan_id, orderSummaryData}) => {

  const [loading, setLoading] = useState(false);

  const handleProceed = async () => {
    


        try {
          
            setLoading(true)
            const headers = await getApiHeader();
            const payload = {
                mobile_number: mobile,
                plan_id: choosedplan_id,
                voucher_count: choosedVoucherCount,
                page: 'confirm'
            };
    
            const response = await axios.post(
                `${SERVER_URL}recharge-voucher-queueing/update-plan-vouchers-queueing`, 
                payload, 
                { headers }
            );


            console.log(response);
            console.log(response.status);
    
            if(response.status === 200) {

              console.log(response?.data?.data?.proceed_payment);

                if (response?.data?.data?.proceed_payment !== undefined && response?.data?.data?.proceed_payment === 1) {
                    handlePage("payment");
                } else {

                    if (response?.data?.data?.orderSummary) {

                        swal("Success", "Vouchers queueing completed successfully!", "success");
                        orderSummaryData(response.data.data.orderSummary);
                        handlePage('summary');
                    } else {

                        swal("Success", "Vouchers queueing completed successfully!", "success");
                        handlePage('home');
                    }
                }

            }
            setLoading(false)

        } catch (error) {
          console.log(error);
          console.log(error?.response);
            setLoading(false)
            if (error?.response?.data?.message) {
              const message=  error?.response?.data?.message
              swal("error",message,"error");
            }else{
               swal("","Something went wrong, Please try again","error");
            }

        } finally {
            setLoading(false);
        }

    
  }


  const handleBack=()=>{
    handlePage("voucher_count")
  }


  return (
  <>
      <div className="formbold-main-wrapper add-plan-wrapper">
        <div className="formbold-form-wrapper add-plan-form pos-rel">

          <h6>Confirmation</h6>
          <hr />


          {loading === true && (
              <Loader />
          )}
          <br/>
          
          
          
      
              <div className="oc-table">
              <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    <th>Plan Name</th>
                    <th>Unit Price</th>
                    <th>Voucher Count</th>
                    <th>Subtotal</th>
                    <th>Discount</th>
                    <th>Net Total</th>
                  </tr>
                </thead>
                <tbody>
                  
                      <tr>
                        <td> <p style={{ textAlign: "center", color: "black" }}>{confirmation?.offerName}</p></td>
                        <td>${confirmation?.unit_amount}</td>
                        <td>{confirmation?.voucher_count}</td>
                        <td>${confirmation?.subtotal}</td>
                        <td>${confirmation?.discount}</td>
                        <td>${confirmation?.net_total}</td>
                       
                      </tr>
                     
                    
                </tbody>
              </table>
              </div></div>
            



            <div className="row mt-4">
              <div className="col-md-6 address-box">
                <h6>Customer Details</h6>
                <p style={{fontSize:"16px", marginBottom:"0px"}}>Mobile: {mobile}</p>
                <p style={{fontSize:"16px", marginBottom:"0px"}}>Name: {confirmation.name}</p>
                <p style={{fontSize:"16px", marginBottom:"0px"}}>Email: {confirmation.email}</p>
                <p style={{fontSize:"16px", marginBottom:"0px"}}>Date: {confirmation.date}</p>
                
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-end">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td style={{textAlign: 'left'}}>Subtotal</td>
                        <td style={{textAlign: 'left'}}>: ${confirmation?.subtotal}</td>
                      </tr>
                      <tr>
                        <td style={{textAlign: 'left'}}>Discount Applied</td>
                        <td style={{textAlign: 'left'}}>: - ${confirmation?.discount}</td>
                      </tr>
                      <tr>
                        <td style={{textAlign: 'left'}}>Wallet Amount Used</td>
                        <td style={{textAlign: 'left'}}>: - ${confirmation?.walletUsedAmount}</td>
                      </tr>
                      <tr>
                        <td style={{textAlign: 'left', fontSize: '20px', fontWeight: '700', color: '#333'}}>Grand Total</td>
                        <td style={{textAlign: 'left', fontSize: '20px', fontWeight: '700', color: '#c11d6c'}}>: ${confirmation?.paybleAmount}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

   
   

            </div>


            <br/>
            <br/>

            <div className="button-container">
              <button onClick={handleBack}>
                Back
              </button>

               <button className="btn btn-send-otp add-mb-otp-btn float-right" type="button" onClick={() => handleProceed()} > Confirm & Proceed </button>
            </div>


          
      </div>
    </div>
  </>
  );
};

export default Confirm;
